<template>
	<div class="flex justify-between mt-4">
		<div class="flex gap-2 [&>button]:bg-background">
			<slot name="left" />
		</div>
		<div 
			class="
				[&>button>span]:hidden sm:[&>button>span]:block
				[&>button]:bg-background
				flex gap-2
			"
		>
			<slot name="right" />
		</div>
	</div>
</template>

<script setup>

</script>

<style scoped>

</style>